import { ErrorProcessor } from "./ErrorProcessor.js";
import { Constants as C, methods as M } from "./methods.js";
export class ServerAdapterBase {
    constructor(id, isMain) {
        this.isMain = isMain;
        this.methods = window._methods.getMethod;
        this.offlineMode = window._globalParams.OfflineMode;
        this.watchers = Object.create(null);
        this.methodTypeHandlers = Object.create(null);
        this.methodTypeHandlers = Object.freeze({
            single: this.processSingle.bind(this),
            intervalStart: this.processIntervalStart.bind(this),
            intervalStop: this.stopInterval.bind(this),
            intervalRequest: this.processIntervalRequest.bind(this),
            continue: this.continue.bind(this),
        });
        this.id = ServerAdapterBase.addWorker(this, id);
        this.timeoutCounter = 0;
        this.inited = true;
    }

    set location(value) {
        ServerAdapterBase._location = value;
    }

    get location() {
        return ServerAdapterBase._location;
    }

    static addWorker(adapter, id) {
        if (typeof ServerAdapterBase.activeWorkers === "undefined") {
            ServerAdapterBase.activeWorkers = new Map();
        }
        if (ServerAdapterBase.activeWorkers.has(id)) {
            var index = 1;
            while (ServerAdapterBase.activeWorkers.has(id + "_" + index))
                index++;
            id = id + "_" + index;
        }
        ServerAdapterBase.activeWorkers.set(id, adapter);
        return id;
    }

    static stopAdapters() {
        if (typeof ServerAdapterBase.activeWorkers !== "undefined") {
            console.log("stopAdapters");
            //console.trace();
            ServerAdapterBase.activeWorkers.forEach((x) => x.stopIntervals());
        }
    }

    static restartAdapters() {
        console.log("restartAdapters");
        //console.trace();
        if (typeof ServerAdapterBase.activeWorkers !== "undefined") {
            ServerAdapterBase.activeWorkers.forEach((x) => {
                x.restartIntervals();
                x.reSubscribe();
            });
        }
    }

    sendRequest(options, callback) {
        const { pack, method, url } = options;
        const headers = {
            url:
                `//${url || this.location.hostname}:${this.location.port}` +
                this.methods(method),
            body: {
                ...pack,
                sessionId: this.sessionId,
            },
        };
        options = {
            ...options,
            headers,
        };
        this.methodTypeHandlers[options.methodType](options, callback);
    }

    // todo: в случае processSingle при возникновении ошибки, всё равно нужно вызвать callback метод
    // todo: иначе Promise не вызовет ни resolve, ни reject и программа так и зависнет.
    // todo: проверить и для других случаев (возможно и там тоже нужно вызывать callback при ошибке)
    postError(answer, callback, callOnError, errorCallback) {
        if (this.timeoutCounter > 3 && !this.offlineMode && this.isMain) {
            //Отслеживаем подключение только в основном потоке
            const event = new CustomEvent("ms_message");
            event.data = { event: "connectionLost" };
            window.dispatchEvent(event);
            this.isConnected = false;
        }

        if (answer && answer.code) {
            this.errorPrecursor(answer, callback);
        } else {
            if (callOnError) {
                callback();
            }
            errorCallback?.();
            this.timeoutCounter++;
        }
    }

    resetTimeout() {
        this.timeoutCounter = 0;
        if (!this.isConnected) {
            this.isConnected = true;
            const event = new CustomEvent("ms_message");
            event.data = { event: "connectRestore" };
            window.dispatchEvent(event);
        }
    }

    set sessionId(value) {
        ServerAdapterBase.sessionId = value;
    }

    get sessionId() {
        return ServerAdapterBase.sessionId;
    }

    stopIntervals() {
        this.watchers &&
            Object.keys(this.watchers).forEach((method) => {
                this.stopInterval({ method });
            });
    }

    errorPrecursor(answer, callback) {
        switch (answer.code) {
            case 2150105088: // 0x80280000
                if (!this.busyResub && this.watchers != undefined) {
                    this.busyResub = true;
                    this.reSubscribe()
                        .then(() => {
                            this.busyResub = false;
                        })
                        .catch(() => {
                            this.busyResub = false;
                        });
                }
                callback && callback(answer);
                break;
            case 2149908480: //0x80250000 sessionId invalid
                ServerAdapterBase.stopAdapters();
                const event = new CustomEvent("ms_message");
                if ($pm.hasPermissions) {
                    if (window._globalParams.DefaultUser)
                        event.data = {
                            event: "switchuser",
                            username: window._globalParams.DefaultUser,
                            password: window._globalParams.DefaultPassword,
                        };
                    else
                        event.data = {
                            event: "reconnect",
                        };
                } else {
                    event.data = {
                        event: "sessionInvalid",
                    };
                }
                window.dispatchEvent(event);
                callback && callback(answer);
                break;
            case 0x80320000: //ошибки тренда
            case 0x802A0000:
            case 0x00A60000:
            case 0x80840000:
            case 0x804A0000:
            case 0x809B0000: // OpcUa_BadNoData
                return callback && callback(answer);
            default:
                ErrorProcessor.ProcessError(answer, callback);
        }
        callback = answer = null;
    }

    logMessage(level, message) {
        const pack = {
            level: level,
            message: message,
        };
        const options = {
            method: M.LogMessage,
            methodType: C.single,
            pack,
        };
        this.sendRequest(options);
    }

    dispose() {
        this.inited = false;
        if (this.watchers) {
            Object.keys(this.watchers).forEach((el) => {
                clearInterval(this.watchers[el].timer);
            });
        }
        delete this.watchers;
        ServerAdapterBase.activeWorkers.delete(this.id);
    }

    continue() { }

    reSubscribe() { }
}
